import type { RouteConfig } from 'react-router-config'
import { withAsync } from '@/components/Async'
import { withAuthRedirect } from '@/components/Authorized/hoc/withAuthRedirect'
import Blank from '@/layouts/Blank'

const routes: RouteConfig[] = [
  // 店铺管理
  {
    alias: 'store_management',
    path: '/stores',
    component: withAuthRedirect(Blank, { first: '/setting/stores/list' }),
    menuTitle: 'frame.stores',
    group: 'setting',
    permissionCode: 'settings:store',
    routes: [
      {
        path: '/list',
        component: withAsync(() => import(/* webpackChunkName: "Stores/List" */ '@/containers/Stores/List')),
        menuTitle: 'frame.stores',
        exact: true,
      },
      {
        path: '/setting/:storeSeq',
        component: withAsync(() => import(/* webpackChunkName: "Stores/List" */ '@/containers/Stores/Setting')),
        menuTitle: 'frame.stores',
        exact: true,
      },
    ],
  },
]

export default routes
